export default [
  {
    text: "Channel",
    colspan: 2,
    align: "left",
    slug: "name",
    defaultSort: "asc"
  },
  {
    text: "Lang",
    align: "center",
    slug: "language",
    defaultSort: "asc"
  },
  {
    text: "Channel Age (mo)",
    align: "center",
    slug: "account_age",
    defaultSort: "desc"
  },
  {
    text: "Primary Game",
    align: "left",
    slug: "this_period.primary_game.title",
    defaultSort: "asc"
  },
  {
    text: "Avg CCV Rank",
    align: "center",
    slug: "this_period.average_viewers_rank",
    defaultSort: "asc"
  },
  {
    text: "Avg CCV",
    align: "center",
    slug: "this_period.average_viewers",
    defaultSort: "desc"
  },
  {
    text: "Avg CCV Growth",
    align: "center",
    slug: "this_period.average_viewers_growth",
    defaultSort: "desc"
  },
  {
    text: "Avg CCV Tier",
    align: "center",
    slug: "this_period.viewership_tier",
    defaultSort: "acs"
  },
  {
    text: "Hours Streamed",
    align: "center",
    slug: "this_period.minutes_streamed",
    defaultSort: "desc"
  },
  {
    text: "Stream Count",
    align: "center",
    slug: "this_period.stream_count",
    defaultSort: "desc"
  },
  {
    text: "Hours Watched",
    align: "center",
    slug: "this_period.hours_watched",
    defaultSort: "desc"
  },
  {
    text: "Followers",
    align: "center",
    slug: "this_period.followers",
    defaultSort: "desc"
  },
  {
    text: "Followers Gained",
    align: "center",
    slug: "this_period.followers_gained",
    defaultSort: "desc"
  },
  {
    text: "Followers Growth",
    align: "center",
    slug: "this_period.growth",
    defaultSort: "desc"
  },
  {
    text: "z-Score",
    align: "center",
    slug: "zScore",
    defaultSort: "desc"
  },
  {
    text: "Followers Gained Per Hour",
    align: "center",
    slug: "this_period.followers_per_hour",
    defaultSort: "desc"
  },
  {
    text: "Standardized Followers Gained Per Hour",
    align: "center",
    slug: "this_period.per_hour_growth",
    defaultSort: "desc"
  }
];
